module.exports = __webpack_public_path__ + "static/media/icon_security.2e89405e.svg";